import {
    LayoutDashboard,
    Users,
    Wallet,
    Percent,
    CalendarRange,
    Megaphone,
    Settings,
    LogOut,
    ShieldCheck,
    ClipboardList
} from 'lucide-react';

export const ROLES = {
    ADMIN: 'ADMIN',
    GERENTE: 'GERENTE',
    GC: 'GESTIÓN DE CUENTAS',
    ATC: 'ATENCIÓN AL CLIENTE',
    MARKETING: 'MARKETING'
};

export const navigation = [
    {
        name: 'Dashboard',
        path: '/',
        icon: LayoutDashboard,
        allowedRoles: [ROLES.ADMIN, ROLES.GERENTE]
    },
    {
        name: 'Personal y Turnos',
        path: '/personal',
        icon: CalendarRange,
        allowedRoles: [ROLES.ADMIN, ROLES.GERENTE]
    },
    {
        name: 'Inventario',
        path: '/inventario',
        icon: Users,
        allowedRoles: [ROLES.ADMIN, ROLES.GERENTE, ROLES.GC, ROLES.ATC]
    },
    {
        name: 'Marketing',
        path: '/marketing',
        icon: Megaphone,
        allowedRoles: [ROLES.ADMIN, ROLES.GERENTE, ROLES.MARKETING]
    },
    {
        name: 'Gestión Financiera',
        path: '/finanzas',
        icon: Wallet,
        allowedRoles: [ROLES.ADMIN, ROLES.GERENTE]
    },
    {
        name: 'Rentabilidad',
        path: '/rentabilidad',
        icon: Percent,
        allowedRoles: [ROLES.ADMIN, ROLES.GERENTE]
    },
    {
        name: 'Centro de Validación',
        path: '/validacion',
        icon: ShieldCheck,
        allowedRoles: [ROLES.ADMIN, ROLES.GERENTE]
    },
    {
        name: 'Supervisión',
        path: '/supervision',
        icon: ClipboardList,
        allowedRoles: [ROLES.ADMIN, ROLES.GERENTE, ROLES.GC, ROLES.ATC]
    },
    {
        name: 'Configuración',
        path: '/configuracion',
        icon: Settings,
        allowedRoles: [ROLES.ADMIN]
    }
];

export const logoutItem = {
    name: 'Cerrar Sesión',
    icon: LogOut,
    action: 'logout'
};

// --- FIX CRÍTICO: Exportar ALL_MODULES para compatibilidad ---
export const ALL_MODULES = navigation;